<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link> >
      <router-link :to="'/persona_vacunapers/' + p_idAtencion + '/' + p_numero + '/' + p_idPersona + '/' + p_edad ">Vacunas</router-link>
      > Plan de Vacunación
    </div>
    <hr>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="filtroVacuna" class="form-label">Filtrar por Vacuna:</label>
        <select id="filtroVacuna" v-model="filtroVacuna" class="form-control">
          <option value="">Todas las Vacunas</option>
          <option v-for="vacuna in vacunas" :key="vacuna" :value="vacuna">{{ vacuna }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="mesDesde" class="form-label">Mes Desde:</label>
        <input type="number" id="mesDesde" v-model="mesDesde" class="form-control" min="0" readonly>
      </div>
      <div class="col-md-2">
        <label for="mesHasta" class="form-label">Mes Hasta:</label>
        <input type="number" id="mesHasta" v-model="mesHasta" class="form-control" min="0" readonly>
      </div>
      <div class="col-md-1 d-flex align-items-end justify-content-center">
        <button @click="cambiarPagina(-1)" class="btn btn-primary" :disabled="mesDesde === 0">
          <span class="material-symbols-outlined" style="font-size:20px;color:white; cursor: pointer; margin-left: 8px;">chevron_left</span>
        </button>
      </div>
      <div class="col-md-1">
        <label for="anioActual" class="form-label">Año:</label>
        <select id="anioActual" v-model="anioActual" class="form-control mx-2">
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <div class="col-md-1 d-flex align-items-end justify-content-center">
        <button @click="cambiarPagina(1)" class="btn btn-primary ml-2" :disabled="mesHasta >= (12*(p_edad-1)+11)">
          <span class="material-symbols-outlined" style="font-size:20px; color:white; cursor: pointer; margin-left: 8px;">chevron_right</span>
        </button>
      </div>
      <div class="col-md-1 d-flex align-items-end justify-content-center">
        <button @click="imprimir" class="btn btn-secondary">
          Imprimir
        </button>
      </div>
    </div>
    <div v-if="datosCargados">
<!--       <h3 class="mt-4 mb-3 text-center">Plan de Vacunación</h3>
 -->      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>Vacuna</th>
              <th v-for="mes in rangoMeses" :key="mes">{{ mes }} meses</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacuna in vacunasFiltradas" :key="vacuna">
              <td>{{ vacuna }}</td>
              <td v-for="mes in rangoMeses" :key="mes" :class="{'bg-warning': isVacunaAplicada(vacuna, mes)}">
                <span v-if="isVacunaAplicada(vacuna, mes)" :title="getDescripcion(vacuna, mes)">✔️</span>
                <span v-else-if="isVacunaPlanificada(vacuna, mes)" :title="getDescripcion(vacuna, mes)">❌</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      p_idPersona: 0,
      p_idAtencion: 0,
      p_numero: '',
      p_edad: 0,
      datosCargados: false,
      vacunas: [],
      vacunacionData: [],
      planVacunacionData: [],
      mesDesde: 0,
      mesHasta: 12,
      filtroVacuna: '',
      anioActual: 1,
      years: []
    };
  },
  computed: {
    rangoMeses() {
      let meses = [];
      for (let i = this.mesDesde; i <= this.mesHasta; i++) {
        meses.push(i);
      }
      return meses;
    },
    vacunasFiltradas() {
      if (this.filtroVacuna) {
        return this.vacunas.filter(vacuna => vacuna === this.filtroVacuna);
      }
      return this.vacunas;
    }
  },
  watch: {
    anioActual(newYear) {
      this.mesDesde = (newYear - 1) * 12;
      this.mesHasta = newYear * 12 - 1;
    }
  },
  methods: {
    async cargarDatos() {
      try {
        const [responsePersona, responsePlan] = await Promise.all([
          api.get(`/vwvacunaperss/idpersona/${this.p_idPersona}`),
          api.get('/vwvacunaplans'),
        ]);
        this.vacunacionData = responsePersona.data;
        this.planVacunacionData = responsePlan.data;
        this.vacunas = [...new Set(this.planVacunacionData.map(item => item.vacunaNombre))];
        this.datosCargados = true;
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    },
    calcularEdadEnMeses(fechaApli, fechaNac) {
      const fechaAplicacion = new Date(fechaApli);
      const fechaNacimiento = new Date(fechaNac);
      const diferenciaMeses = (fechaAplicacion.getFullYear() - fechaNacimiento.getFullYear()) * 12;
      return diferenciaMeses - fechaNacimiento.getMonth() + fechaAplicacion.getMonth();
    },
    isVacunaAplicada(vacuna, mes) {
      return this.vacunacionData.some(item => item.vacunaNombre === vacuna && this.calcularEdadEnMeses(item.fechaApli, item.personaFechaNac) === mes);
    },
    isVacunaPlanificada(vacuna, mes) {
      return this.planVacunacionData.some(item => item.vacunaNombre === vacuna && item.edadMeses === mes);
    },
    getDescripcion(vacuna, mes) {
      const vacunaItem = this.vacunacionData.find(item => 
        item.vacunaNombre === vacuna && 
        this.calcularEdadEnMeses(item.fechaApli, item.personaFechaNac) === mes
      );

      if (!vacunaItem) return '';  // Si no se encuentra el item, retorna cadena vacía.

      // Función para formatear la fecha en DD-MM-YYYY
      const formatDate = (date) => {
        if (!date) return '';  // Si la fecha es nula o indefinida, no hacer nada.
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      // Construimos la descripción condicionalmente
      let descripcion = vacunaItem.observacion;

      // Agregar vacunaProdNombre si no es nulo o indefinido
      if (vacunaItem.vacunaProdNombre) {
        descripcion += "; " + vacunaItem.vacunaProdNombre;
      }

      // Agregar lote si no es nulo o indefinido
      if (vacunaItem.lote) {
        descripcion += "; " + vacunaItem.lote;
      }

      // Agregar la fecha formateada si existe fechaApli
      if (vacunaItem.fechaApli) {
        descripcion += "; " + formatDate(vacunaItem.fechaApli);
      }

      return descripcion;
    },
    cambiarPagina(direccion) {
      const nuevoAnio = this.anioActual + direccion;
      if (nuevoAnio >= 0) {
        this.anioActual = nuevoAnio;
      }
    },
    inicializarAnios() {
      for (let year = 1; year <= 5; year++) {
        this.years.push(year);
      }
    },
    imprimir() {
      window.print();
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.p_idPersona = this.$route.params.p_idpersona;
    this.p_idAtencion = this.$route.params.p_idatencion;
    this.p_numero = this.$route.params.p_numero;
    this.p_edad = this.$route.params.p_edad;
    this.cargarDatos();
    this.inicializarAnios();
  },
};
</script>
<style scoped>
.breadcrumb-container {
  margin-bottom: 15px;
}

h3.text-center {
  text-align: center;
}

.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

th, td {
  padding: 10px;
}

.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}

.d-flex {
  display: flex;
}

.align-items-end {
  align-items: flex-end;
}

.justify-content-center {
  justify-content: center;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.year-label {
  font-weight: bold;
  font-size: 1.2rem;
}
</style>